import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-firreport',
  templateUrl: './firreport.component.html',
  styleUrls: ['./firreport.component.scss']
})
export class FIRReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
